module.exports = __webpack_public_path__ + "static/media/unapproved.f9482bb7.svg";